<template>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <role-table />
        </div>
      </div>
      <!-- <div class="row">
        <div class="col-12">
          <projects-table />
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  import RoleTable from "./components/RoleTable";
  // import ProjectsTable from "./components/ProjectsTable";
  
  export default {
    name: "Users",
    components: {
      RoleTable,
      // ProjectsTable,
    },
  };
  </script>
  